import { reaction } from '../../utils/preact-utils';
import { AdContainerStore } from '../../stores/ad-container.store';
import { isFeatureEnable } from '../../features-enabling';
import { sendCustomTrack } from '../../TrackAnalyticsHelper';

const SIZE_RATIO_THRESHOLD = 0.99;

export class EdgeToEdgeDectectionIssueHandler {
  adContainerStore: AdContainerStore;

  constructor({ adContainerStore }: { adContainerStore: AdContainerStore }) {
    this.adContainerStore = adContainerStore;
    let unsubscribeReaction: () => void;

    unsubscribeReaction = reaction(
      () => this.adContainerStore.isViewable.value,
      (isViewable: boolean) => {
        if (isViewable) {
          this.sendHasEdgeToEdgeIssueEvent();
          unsubscribeReaction && unsubscribeReaction();
        }
      },
      true
    );
  }

  sendHasEdgeToEdgeIssueEvent(): void {
    const { width: maxWidth, height: maxHeight } = window.mraid.getMaxSize();
    const {
      width: screenWidth,
      height: screenHeight
    } = window.mraid.getScreenSize();
    const hasMraidSizeDiscrepancy =
      maxWidth / screenWidth < SIZE_RATIO_THRESHOLD ||
      maxHeight / screenHeight < SIZE_RATIO_THRESHOLD;
    if (isFeatureEnable('edgeToEdgeDetection') && hasMraidSizeDiscrepancy) {
      sendCustomTrack('android_edge_issue');
    }
  }
}
